import { Box, Link, Typography } from "@mui/material";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import "./translations";

import { cookieBanner } from "@/utils/tracking/tealium-tracker";

const deprecatedDomains = [
  "app.dev.indexportfolio.sprengnetter.de",
  "app.test.indexportfolio.sprengnetter.de",
  "app.indexportfolio.sprengnetter.de",
];

const isDeprecatedDomain = deprecatedDomains.includes(window.location.hostname);

export const Footer = (): JSX.Element => {
  const { t } = useTranslation("Footer");

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        padding: "16px",
        backgroundColor: (theme) => theme.palette.common.white,
        color: (theme) => theme.palette.primary.main,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={{ display: "flex", gap: "16px" }}>
        {!isDeprecatedDomain && (
          <Link
            href="#"
            underline="none"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              cookieBanner();
            }}
          >
            <Typography>{t("cookiesSettings")}</Typography>
          </Link>
        )}
        <Link href="https://www.sprengnetter.de/agb-von-sprengnetter/" underline="none" target="_blank">
          <Typography>{t("sprengnetter")}</Typography>
        </Link>
        <Link href="https://www.sprengnetter.de/datenschutz/" underline="none" target="_blank">
          <Typography>{t("privacyProtection")}</Typography>
        </Link>
        <Link href="https://www.sprengnetter.de/impressum-von-sprengnetter/" underline="none" target="_blank">
          <Typography>{t("legalData")}</Typography>
        </Link>
      </Box>
    </Box>
  );
};
